import React from "react";
import { Spinner } from "react-bootstrap";
import "./styles.scss";

const Loader = () => {
  return (
    <div className="loader">
      <Spinner animation="grow" />
    </div>
  );
};

export default Loader;
